import { DOCUMENT } from "@angular/common";
import {
  FactoryProvider,
  Inject,
  Injectable,
  Optional,
  SkipSelf
} from "@angular/core";

@Injectable()
export class OverlayContainerService {
  private documentRef: Document;

  protected element: HTMLElement | undefined;

  constructor(@Inject(DOCUMENT) document: any) {
    this.documentRef = document;
  }

  getElement(): HTMLElement {
    if (this.element == null) {
      let existingContainer: HTMLElement | undefined = (
        Array.from(this.documentRef.body.children) as HTMLElement[]
      ).find((elem) => {
        return elem.classList.contains("overlay-container");
      });

      if (existingContainer != null) {
        existingContainer.remove();
      }

      this.element = this.documentRef.createElement("div");
      this.element.classList.add("overlay-container");
      this.documentRef.body.appendChild(this.element);
    }
    return this.element;
  }

  /**
   * @internal
   */
  destroy(): void {
    if (this.element == null) {
      return;
    }

    this.element.remove();
    this.element = undefined;
  }
}

/**
 * @internal
 */
export function OVERLAY_CONTAINER_PROVIDER_FACTORY(
  document: Document,
  parent?: OverlayContainerService
): OverlayContainerService {
  if (parent != null) {
    return parent;
  }
  return new OverlayContainerService(document);
}

/**
 * @internal
 */
export const OVERLAY_CONTAINER_PROVIDER: FactoryProvider = {
  provide: OverlayContainerService,
  deps: [DOCUMENT, [new Optional(), new SkipSelf(), OverlayContainerService]],
  useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
};
